module.exports = __webpack_public_path__ + "img/sydl2.c093cedd.svg";